import styled, { css } from 'styled-components';
import {} from 'next/config';

export const StyledHero = styled.div`
  background-color: ${props => props.theme.colors.get(props.backgroundColor)};
  position: relative;
  text-align: center;
  z-index: 2;
`;

export const BackgroundImage = styled.div`
  ${props => {
    if (props.image.srcSet) {
      return props.image.srcSet
        .map(src =>
          src.media
            ? css`
                @media ${src.media} {
                  min-height: ${src.aspectRatio.split('%')[0]}vw;
                }
              `
            : css`
                min-height: ${src.aspectRatio.split('%')[0]}vw;
              `,
        )
        .reverse();
    }

    return css`
      min-height: ${((props.image.height / props.image.width) * 100).toFixed(
        2,
      )}vw;
    `;
  }}
  @media ${props => props.theme.tablet} {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
    min-height: unset;
  }
`;

export const ContentContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: ${props => props.horizontalOrientation.justify};
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
  ${props => {
    if (props.image.srcSet) {
      return props.image.srcSet
        .map(src =>
          src.media
            ? css`
                @media ${src.media} {
                  min-height: ${src.aspectRatio.split('%')[0]}vw;
                }
              `
            : css`
                min-height: ${src.aspectRatio.split('%')[0]}vw;
              `,
        )
        .reverse();
    }

    return css`
      min-height: ${((props.image.height / props.image.width) * 100).toFixed(
        2,
      )}vw;
    `;
  }}

  @media (max-width: 767px) {
    min-height: unset;
  }
`;

export const Content = styled.div`
  align-items: ${props => props.horizontalOrientation.align};
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing(4, 5, 6)};
  text-align: ${props => props.horizontalOrientation.text};
  width: 100%;
  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(8, 10, 16)};
    width: 70%;
  }
  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(10, 20, 32)};
  }
`;

export const Header = styled.h1`
  ${props => props.theme.typography.heading3}
  color: ${props => props.fontColor && props.theme.colors.get(props.fontColor)};
  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.heading1}
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

export const Subheader = styled.p`
  ${props => props.theme.typography.heading5}
  margin: ${props => props.theme.spacing(4, 0)};
  max-width: 400px;
  color: ${props => props.fontColor && props.theme.colors.get(props.fontColor)};
  @media ${props => props.theme.tablet} {
    margin-top: ${props => props.theme.spacing(0)};
  }
`;

export const ButtonWrapper = styled.div`
  margin: ${props => props.theme.spacing(2, 0, 8)};
  @media ${props => props.theme.tablet} {
    margin: ${props => props.theme.spacing(6, 0, 0)};
  }
`;

export const CountdownAndLink = styled.div`
  text-align: center;
`;
